// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.histogram-outer-container {
    padding: 0 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}

.histogram-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 1.35rem;
}

.histogram-row:not(:last-child) {
    margin-bottom: 0.5rem;
}

.histogram-label {
    width: 10%;
    font-weight: 600;
    font-size: 1rem;
}

.histogram-bar-container {
    width: 90%;
    height: 100%;
}

.histogram-bar {
    height: 100%;
    transition: width 0.5s linear;
    box-sizing: border-box;
    font-size: 1rem;
    display: flex;
    justify-content: end;
    align-items: center;
    color: white;
}

.histogram-count-label {
    padding-right: 0.3rem;

}

.histogram-count-label-small {
    transform: translateX(100%);
    color: var(--default-text-color);
    padding-left: 0.3rem;
}

.histogram-bars-container {
    width: 90%;
    border-left: 1px solid darkgray;
}

.histogram-label-container {
display: flex
;
    flex-direction: column;
    justify-content: space-evenly;
}

.histogram-bar.histogram-bar-inactive {
    background-color: var(--victory-modal-gray);
}`, "",{"version":3,"sources":["webpack://./src/Histogram.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,qBAAqB;;AAEzB;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,+BAA+B;AACnC;;AAEA;AACA;AACA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,2CAA2C;AAC/C","sourcesContent":[".histogram-outer-container {\n    padding: 0 1rem;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n}\n\n.histogram-row {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    height: 1.35rem;\n}\n\n.histogram-row:not(:last-child) {\n    margin-bottom: 0.5rem;\n}\n\n.histogram-label {\n    width: 10%;\n    font-weight: 600;\n    font-size: 1rem;\n}\n\n.histogram-bar-container {\n    width: 90%;\n    height: 100%;\n}\n\n.histogram-bar {\n    height: 100%;\n    transition: width 0.5s linear;\n    box-sizing: border-box;\n    font-size: 1rem;\n    display: flex;\n    justify-content: end;\n    align-items: center;\n    color: white;\n}\n\n.histogram-count-label {\n    padding-right: 0.3rem;\n\n}\n\n.histogram-count-label-small {\n    transform: translateX(100%);\n    color: var(--default-text-color);\n    padding-left: 0.3rem;\n}\n\n.histogram-bars-container {\n    width: 90%;\n    border-left: 1px solid darkgray;\n}\n\n.histogram-label-container {\ndisplay: flex\n;\n    flex-direction: column;\n    justify-content: space-evenly;\n}\n\n.histogram-bar.histogram-bar-inactive {\n    background-color: var(--victory-modal-gray);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
